import React from 'react';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

// Reusable form field wrapper
export const FormField = ({ label, required, children }) => (
  <div className="space-y-2">
    <label className="text-sm font-medium text-darkBrown">
      {label} {required && '*'}
    </label>
    {children}
  </div>
);

// Text input field
export const TextInputField = ({ label, required, testId, ...inputProps }) => (
  <FormField label={label} required={required}>
    <Input
      data-testid={testId}
      required={required}
      className="border-gray-300 focus:border-primaryOrange"
      {...inputProps}
    />
  </FormField>
);

// Textarea field
export const TextAreaField = ({ label, required, testId, rows = 5, ...inputProps }) => (
  <FormField label={label} required={required}>
    <Textarea
      data-testid={testId}
      required={required}
      rows={rows}
      className="border-gray-300 focus:border-primaryOrange resize-none"
      {...inputProps}
    />
  </FormField>
);
